import { Component, ViewChild } from "@angular/core";
import { AppConfig } from "../../../app.config";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { StatusService } from "../../../services/status.service";
import { PopupsService } from "../popups.service";
import { UsuarioGuiasService } from "../../../services/data-services/usuario.guias.service";
import { MatDialog } from "@angular/material/dialog";
import { MatButtonToggleGroup } from "@angular/material/button-toggle";
import { ErrorHandlerService } from "../../../services/errorHandler.service";
import { ErroPopupDataModel } from "src/app/models/ErroPopupDataModel";
import { ErroPopUpComponent } from "../mensagem/erro-popup.component";

@Component({
  selector: "app-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["../popups-styles.scss", "./feedback.component.scss"],
})
export class FeedbackComponent {
  @ViewChild(MatButtonToggleGroup) btnGroup;
  public textoFeedback: string;

  private headers = new HttpHeaders({
    "content-type": "application/json",
  });
  constructor(
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private statusService: StatusService,
    private popupSerice: PopupsService,
    private guiasService: UsuarioGuiasService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  public criarTicket(): void {
    if (
      !this.btnGroup.value ||
      !this.textoFeedback ||
      (this.textoFeedback && this.textoFeedback.match(/^ *$/) !== null)
    ) {
      const data = new ErroPopupDataModel();
      data.titulo = "Feedback inválido";
      data.mensagem =
        "Por favor selecione uma das opções e escreva um comentário para enviar um feedback";
      this.dialog.open(ErroPopUpComponent, {
        width: "450px",
        data: data,
      });

      return;
    }

    const idLei = this.guiasService.valueGuiaAtiva.idLei
      ? this.guiasService.valueGuiaAtiva.idLei
      : "Nova Guia";
    const dadosAdicionais = "<br/><br/><bold>Lei aberta: " + idLei + "</bold>";

    const description =
      this.textoFeedback.replace(/\r?\n/g, "<br/>") + dadosAdicionais;

    // O envio do e-mail para o suporte é feito pela API
    lastValueFrom(
      this.httpClient.post(
        AppConfig.apiEndpoint + "/api/suporte/",
        `"${description + "::" + this.btnGroup.value}"`,
        { headers: this.headers }
      )
    )
      .then(() => {
        this.statusService.setMessage("Feedback enviado com sucesso!");
        this.popupSerice.fecharPopups();
      })
      .catch((error) => {
        this.errorHandlerService.handleError(error);

        this.statusService.setMessage(
          "Erro ao enviar feedback. Tente novamente mais tarde"
        );
        this.popupSerice.fecharPopups();
      });
  }

  public btnCancelarClick() {
    this.popupSerice.fecharPopups();
  }
}
